module.exports = __webpack_public_path__ + "static/img/home_jpkc_pic1.ff44116.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_jpkc_pic1.png
// module id = oqFc
// module chunks = 0